module.exports = __webpack_public_path__ + "img/Julien Bouteloup.4c404abc.jpg";